<template>
  <div class="overview-component text-none">
    <v-progress-circular indeterminate color="primary" class="progress" v-if="loading"></v-progress-circular>
    <div v-else class="mb-0 mb-md-6 reservation-screen-wrapper d-flex flex-column pa-6 align-start">

      <div class="reservation-screen-header d-flex flex-row justify-center text-left">
        {{$t('user.personal_data.header')}}
      </div>
      <div class="input-wrapper text-left mt-8" v-if="edit">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.name_label')}}</div>
        <input type="text" :class="[$vuetify.display.mobile ? 'long' : '', 'input']" id="name" v-model="userData.name" />
        <div class="validation mt-1 text-left" v-if="!validateField('name')">
          {{$t('user.personal_data.name_validation_empty_msg')}}
        </div>
      </div>
      <div v-else class="input-wrapper text-left mt-8">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.name_label')}}</div>
        <input class="input disabled" :value="userData.name"/>
      </div>
      <div class="input-wrapper text-left mt-8" v-if="edit">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.lastname_label')}}</div>
        <input type="text" class="input" id="lastname" v-model="userData.lastname" />
        <div class="validation mt-1 text-left" v-if="!validateField('lastname')">
          {{$t('user.personal_data.lastname_validation_empty_msg')}}
        </div>
      </div>
      <div v-else class="input-wrapper text-left mt-8">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.lastname_label')}}</div>
        <input class="input disabled" :value="userData.lastname"/>
      </div>
      <div class="input-wrapper text-left mt-8" v-if="edit">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.phone_label')}}</div>
        <input type="text" class="input" id="phone" v-model="userData.phone" @keypress="onlyPhoneKey($event)" />
        <div class="validation mt-1 text-left" v-if="!validateField('phone')">
          {{$t('user.personal_data.phone_validation_empty_msg')}}
        </div>
      </div>
      <div v-else class="input-wrapper text-left mt-8">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.phone_label')}}</div>
        <input class="input disabled" :value="userData.phone"/>
      </div>
      <div class="input-wrapper mt-8" v-if="edit">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.birth_date_label')}}</div>
        <div class="full-date-wrapper text-left d-flex flex-row">
          <span class="date-wrapper mr-2 flex-md-grow-0 flex-grow-1">
            <select :class="$vuetify.display.mobile ? 'long select pr-8' : 'select pr-8'"
              v-model="userData.birthdate.day" id="birthdate_day">
              <option value="" selected disabled>{{$t('user.personal_data.birth_date_day_label')}}</option>
              <option v-for="index in 31" :key="index" :value="index.toString().padStart(2, '0')">{{ index }}</option>
            </select>
            <div class="chevron">
              <img :src="chevron_icon" />
            </div>
          </span>
          <span class="date-wrapper mr-2 flex-md-grow-0 flex-grow-1">
            <select :class="$vuetify.display.mobile ? 'long select pr-8' : 'select pr-8'"
              v-model="userData.birthdate.month" id="birthdate_month">
              <option value="" selected disabled>{{$t('user.personal_data.birth_date_month_label')}}</option>
              <option value="01">{{$t('months.january')}}</option>
              <option value="02">{{$t('months.february')}}</option>
              <option value="03">{{$t('months.march')}}</option>
              <option value="04">{{$t('months.april')}}</option>
              <option value="05">{{$t('months.may')}}</option>
              <option value="06">{{$t('months.june')}}</option>
              <option value="07">{{$t('months.july')}}</option>
              <option value="08">{{$t('months.august')}}</option>
              <option value="09">{{$t('months.september')}}</option>
              <option value="10">{{$t('months.october')}}</option>
              <option value="11">{{$t('months.november')}}</option>
              <option value="12">{{$t('months.december')}}</option>
            </select>
            <div class="chevron">
              <img :src="chevron_icon" />
            </div>
          </span>
          <span class="date-wrapper flex-md-grow-0 flex-grow-1">
            <select :class="$vuetify.display.mobile ? 'long select pr-8' : 'select pr-8'"
              v-model="userData.birthdate.year" id="birthdate_year">
              <option value="" selected disabled>{{$t('user.personal_data.birth_date_year_label')}}</option>
              <option v-for="index in 100" :key="index" :value="2022 - index">{{ 2022 - index }}</option>
            </select>
            <div class="chevron">
              <img :src="chevron_icon" />
            </div>
          </span>
        </div>
        <div class="validation mt-1 text-left" v-if="!validateField('birthdate')">
          {{$t('user.personal_data.birth_date_validation_invalid_msg')}}
        </div>
        <div class="validation mt-1 mb-1 text-left" v-if="!validateField('pesel_birthdate')">
          {{$t('user.personal_data.pesel_validation_invalid_birth_date_msg')}}
        </div>
      </div>
      <div v-else class="input-wrapper text-left mt-8">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.birth_date_label')}}</div>
        <input class="input disabled" 
          :value="userData.birthdate.day ? userData.birthdate.day.padStart(2,'0') + '-' + userData.birthdate.month.padStart(2,'0') + '-' + userData.birthdate.year : ''"
        />
      </div>
      <!-- gender -->
      <div class="input-wrapper text-left mt-8" v-if="edit">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.gender_label')}}</div>
        <div class="select-wrapper">
          <select class="select" v-model="userData.gender" id="gender">
            <option value="" selected disabled>{{$t('select_from_list_label')}}</option>
            <option v-for="(gender, index) in genders" :value="gender.code" :key="index">
              {{ gender.name }}</option>
          </select>
          <div class="chevron">
            <img :src="chevron_icon" />
          </div>
        </div>
        <div class="validation mt-1 text-left" v-if="!validateField('gender')">
          {{$t('user.personal_data.gender_validation_empty_msg')}}
        </div>
      </div>
      <div v-else class="input-wrapper text-left mt-8">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.gender_label')}}</div>
        <input class="input disabled" :value="genders.find(e => e.code == userData.gender)?.name"/>
      </div>
      <!-- end gender -->
      <div class="input-wrapper text-left mt-8" v-if="edit">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.citizenship_label')}}</div>
        <div class="select-wrapper">
          <select class="select" v-model="userData.citizenship" id="citizenship">
            <option value="" selected disabled>{{$t('select_from_list_label')}}</option>
            <option v-for="(citizenship, index) in citizenships" :value="citizenship.code" :key="index">
              {{ citizenship.value }}</option>
          </select>
          <div class="chevron">
            <img :src="chevron_icon" />
          </div>
        </div>
        <div class="validation mt-1 text-left" v-if="!validateField('citizenship')">
          {{$t('user.personal_data.citizenship_validation_empty_msg')}}
        </div>
      </div>
      <div v-else class="input-wrapper text-left mt-8">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.citizenship_label')}}</div>
        <input class="input disabled" :value="citizenships.find(e => e.code == userData.citizenship)?.value"/>
      </div>

      <div class="input-wrapper mt-8 text-left" v-if="edit">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.pesel_number_label')}}</div>
        <input type="text" class="input" v-model="userData.pesel" @keypress="onlyNumberKey($event)"
          @paste="onlyNumberPaste($event)" maxLength="11" :disabled="userData.noPesel" id="pesel" />
        <div class="validation mt-1 mb-1 text-left" v-if="!validateField('pesel')">
          {{$t('user.personal_data.pesel_validation_invalid_msg')}}
        </div>
        <div class="validation mt-1 mb-1 text-left" v-if="!validateField('pesel_birthdate')">
          {{$t('user.personal_data.pesel_validation_invalid_birth_date_msg')}}
        </div>
        <label class="container input-label mt-2" v-if="edit">{{$t('user.personal_data.no_pesel_label')}}
          <input type="checkbox" v-model="userData.noPesel" id="noPesel">
          <span class="checkmark"></span>
        </label>
      </div>
      <div v-else>
        <div v-if="!userData.noPesel" class="input-wrapper text-left mt-8">
          <div class="input-label text-left mb-1">{{$t('user.personal_data.pesel_number_label')}}</div>
        <input class="input disabled" :value="userData.pesel"/>
        </div>
      </div>

      <div class="wrapper" v-if="userData.noPesel === true">
        <div class="input-wrapper mt-8 text-left" v-if="edit">
          <div class="input-label text-left mb-1 ml-6">{{$t('user.personal_data.document_type_label')}}</div>
          <div class="select-wrapper inside ml-6 mr-6">
            <select class="select" v-model="userData.documentType" id="documentType">
              <option value="" selected disabled>{{$t('select_from_list_label')}}</option>
              <option v-for="(documentType, index) in filteredDocumentTypes" :value="documentType.code" :key="index">
                {{documentType.value}}</option>
            </select>
            <div class="chevron">
              <img :src="chevron_icon" />
            </div>
          </div>
          <div class="validation mt-1 ml-6 mr-6 text-left" v-if="!validateField('documentType')">
            {{$t('user.personal_data.document_type_validation_empty_msg')}}
          </div>
        </div>
        <div v-else class="input-wrapper text-left mt-8">
          <div class="input-label text-left mb-1">{{$t('user.personal_data.document_type_label')}}</div>
          <input class="input disabled" :value="documentTypes.find(e => e.code == userData.documentType)?.value"/>
        </div>
      </div>

      <div class="wrapper" v-if="userData.noPesel === true">
        <div class="input-wrapper text-left mt-8" v-if="edit">
          <div class="input-label text-left mb-1 ml-6">{{$t('user.personal_data.document_number_label')}}</div>
          <div class="ml-6">
            <input type="text" class="input" v-model="userData.documentNumber" id="documentNumber" />
          </div>
          <div class="validation mt-1 ml-6 mr-6 text-left" v-if="!validateField('documentNumber')">
            {{$t('user.personal_data.document_number_validation_empty_msg')}}
          </div>
        </div>
        <div  v-else class="input-wrapper text-left mt-8">
          <div class="input-label text-left mb-1">{{$t('user.personal_data.document_number_label')}}</div>
          <input class="input disabled" :value="userData.documentNumber"/>
        </div>
      </div>

      <div class="wrapper" v-if="userData.noPesel === true">
        <div class="input-wrapper mt-8 text-left" v-if="edit">
          <div class="input-label text-left mb-1 ml-6">{{$t('user.personal_data.document_country_label')}}</div>
          <div class="select-wrapper inside ml-6 mr-6">
            <select class="select" v-model="userData.documentCountry" id="documentCountry">
              <option value="" selected disabled>{{$t('select_from_list_label')}}</option>
              <option v-for="(documentCountry, index) in documentCountries" :value="documentCountry.name" :key="index">
                {{ documentCountry.value }}</option>
            </select>
            <div class="chevron">
              <img :src="chevron_icon" />
            </div>
          </div>
          <div class="validation mt-1 ml-6 mr-6 text-left" v-if="!validateField('documentCountry')">
            {{$t('user.personal_data.document_country_validation_empty_msg')}}
          </div>
        </div>
        <div v-else class="input-wrapper text-left mt-8">
          <div class="input-label text-left mb-1">{{$t('user.personal_data.document_country_label')}}</div>
          <input class="input disabled" :value="documentCountries.find(e => userData.documentCountry == e.name).value"/>
        </div>

      </div>
      <div class="input-wrapper text-left mt-8" v-if="edit">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.location_label')}}</div>
        <div class="select-wrapper">
          <select class="select" v-model="userData.location" id="location">
            <option value="" selected disabled>{{$t('select_from_list_label')}}</option>
            <option v-for="(location, index) in locations" :value="location.code" :key="index">
              {{ $t('INVICTA-CLINIC') }} {{ location.name }}
            </option>
          </select>
          <div class="chevron">
            <img :src="chevron_icon" />
          </div>
        </div>
        <div class="validation mt-1 text-left" v-if="!validateField('location')">
          {{$t('user.personal_data.location_validation_empty_msg')}}
        </div>
      </div>
      <div v-else class="input-wrapper text-left mt-8">
        <div class="input-label text-left mb-1">{{$t('user.personal_data.location_label')}}</div>
          <input class="input disabled" :value="getClinicName()"/>
      </div>
      
      <!-- <v-spacer v-if="$vuetify.display.mobile"></v-spacer> -->
      <v-btn v-if="edit" rounded color="primary" flat @click="sendUserData" height="40" class="mt-2 px-6 py-2"
        :class="[$vuetify.display.mobile ? 'long' : '','mt-12 save_button']">
        <v-progress-circular indeterminate color="white" size="22" width="2" v-if="loading_save"></v-progress-circular>
        <span v-else>{{$t('save_changes_btn')}}</span>
      </v-btn>
      <v-btn v-else rounded color="white" flat @click="toggleEdit" height="40" class="mt-2 px-6 py-2"
        :class="[$vuetify.display.mobile ? 'long' : '','edit_button d-flex justify-center mt-12']"
        :disabled="userData.file_id">
        <img :src="pen_icon" class="mr-5"/><span>{{$t('edit_btn')}}</span>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue';
import axios from "axios";

export default {
  name: "overview-component",
  data: () => {
    return {
      loading: false,
      loading_save: false,
      validationOn: false,
      edit: false,
      userData: {
        name: '',
        lastname: '',
        phone: '',
        birthdate: {
          day: '',
          month: '',
          year: ''
        },
        citizenship: '',
        pesel: '',
        noPesel: false,
        gender: '',
        documentType: '',
        filteredDocumentTypes: '',
        documentNumber: '',
        documentCountry: '',
        location: '',
        file_id: null,
      },
			citizenships: [],
			locations: [],
			documentTypes: [],
			documentCountries: [],
    }
  },
  setup() {
    const chevron_icon = computed({
      get: () => { return require('../assets/icons/chevron-down.svg'); }
    })
    const pen_icon = computed({
      get: () => { return require('../assets/icons/pen.svg'); }
    })
    return {
      chevron_icon,
      pen_icon
    }
  },
  computed: {
		genders() {
			return [
				{
					name: this.$t('MALE'),
					code: "male",
				},
				{
					name: this.$t('FEMALE'),
					code: "female",
				}
			]
		},
  },
  mounted() {
    this.loading = true;
    Promise.all([
      this.getDicts(),
      this.getLastData()
    ])
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      this.loading = false;
    })
    this.$store.dispatch('breadcrumbModule/setRoute', [{
        name: 'breadcrumb.want_to_be_a_parent',
        url: `https://bank.invicta.pl${ this.$t('bank_invicta_path.planning_parenthood') }`,
        absolute: true
      },{
        name: 'breadcrumb.dashboard',
        url: '/dashboard?selected=personal-details'
      },
      {
        name: 'breadcrumb.dashboard_labels.personal_data',
        url: ''
      }
    ])
  },
	watch: {
		'userData.noPesel': {
			handler() {
				this.userData.pesel = ''
			}
		},
    '$route.query._locale': {
      handler(locale) {
        this.getDicts(locale)
      }
    }
	},
  methods: {
		getDicts(locale = this.$i18n.locale) {
			return new Promise((resolve, reject) => {
			axios.get(`/api/personal_data/dictionary?language=${locale}`)
				.then((response) => {
					this.citizenships = response.data.citizenship;
					this.locations = response.data.location;
					this.documentTypes = response.data.doc_id;

          // extend dictionaries to account for strange document id
          this.filteredDocumentTypes = this.documentTypes.filter(e => 
            e.code == 'ID_CARD'  ||
            e.code == 'PASSPORT' ||
            e.code == 'DRIVING_LICENSE'
          )

					this.documentCountries = response.data.country;
					resolve(response);
				})
				.catch(error => {
					console.error(error);
					reject(error)
				})
			})
		},
    getLastData() {
      return new Promise((resolve, reject) => {
        axios.get('/api/personal_data/last')
          .then((response) => {
            if (response.data) {
              let data = response.data.record_data;
              this.userData = {
                name: data.first_name,
                lastname: data.last_name,
                phone: data.phone_number,
                birthdate: {
                  day: data.birth_date.split('-')[2],
                  month: data.birth_date.split('-')[1],
                  year: data.birth_date.split('-')[0]
                },
                citizenship: data.citizenship,
                pesel: data.is_pesel ? data.pesel_number : '',
                noPesel: !data.is_pesel,
                gender: data.gender,
                documentType: data.is_pesel ? '' : data.identity_doc_type,
                documentNumber: data.is_pesel ? '' : data.identity_doc_number,
                documentCountry: data.is_pesel ? '' : this.documentCountries.find(e => e.name == data.identity_doc_country).name,
                location: data.location_of_treatment,
                file_id: data.file_id
              },
                resolve(response);
            } else {
              reject(response);
            }
          })
          .catch(error => {
            console.error(error);
            reject(error)
          })
      })
    },
    validateField(field) {
      if (this.validationOn) {
        switch (field) {
          case "pesel_birthdate": {
            let result = true;
            if (this.userData.birthdate.year && this.userData.birthdate.month && this.userData.birthdate.day && this.userData.pesel)
              result = this.userData.birthdate.year.toString().slice(2, 4) == this.userData.pesel.slice(0, 2) &&
                parseInt(this.userData.birthdate.month) == parseInt(this.userData.pesel.slice(2, 4)) % 20 &&
                this.userData.birthdate.day == this.userData.pesel.slice(4, 6);
            return result;
          }
          case "birthdate": {
            return this.userData.birthdate.year && this.userData.birthdate.month && this.userData.birthdate.day;
          }
          case "pesel": {
            let result = 0;
            const weights = [1, 3, 7, 9, 1, 3, 7, 9, 1, 3];
            for (let i = 0; i < 10; i++) {
              result += (weights[i] * this.userData.pesel[i]);
            }
            return this.userData.noPesel || ((10 - result % 10) % 10 == this.userData.pesel[10]);
          }
          case "documentType":
          case "documentNumber":
          case "documentCountry": {
            return !this.userData.noPesel || this.userData[field]
          }
          default: {
            return this.userData[field];
          }
        }
      } else {
        return true;
      }
    },
    toggleEdit() {
      this.edit = true;
      window.scrollTo({top: 0});
    },
    getClinicName() {
      let location = this.locations.find(e => e.code == this.userData.location)
      if (location) {
        return this.$t('INVICTA-CLINIC') + ' ' + location.name
      } else {
        return null
      }
    },
		sendUserData() {
      this.validationOn = true;
			this.$nextTick(() => {
				this.screen_ready = false;
				let errors = document.querySelector('.validation');
				if(errors) {
					errors.scrollIntoView({behavior: 'smooth', block: 'center'});
				} else {
          this.loading_save = true;
          let payload = {
            first_name: this.userData.name,
            last_name: this.userData.lastname,
            phone_number: this.userData.phone,

            birth_date: `${this.userData.birthdate.year}-${this.userData.birthdate.month}-${this.userData.birthdate.day}`,

            citizenship: this.userData.citizenship,
            citizenship_name: this.citizenships.find(e => this.userData.citizenship == e.code)?.name || "",
            pesel_number: this.userData.noPesel ? '' : this.userData.pesel,
            gender: this.userData.gender,
            identity_doc_type: this.userData.noPesel ? this.userData.documentType : '',
            identity_doc_number: this.userData.noPesel ? this.userData.documentNumber : '',
            identity_doc_country: this.userData.noPesel ? this.userData.documentCountry : '',
            location_of_treatment: this.userData.location,
            is_pesel: !this.userData.noPesel,
          }
          return new Promise((resolve, reject) => {
            axios.post('api/personal_data', payload)
            .then(response => {
              resolve(response.data.personal_data_record_id);
              this.$root.$alertMessageRef.showAlert(
                this.$t('alert.USER_DATA_SAVE_SUCCESS.title'),
                null,
                {
                  link: false,
                  action: false,
                  timeout: true,
                  timeoutDuration: 3000,
                  color: 'rgba(32, 30, 76, 1)',
                  backgroundColor: 'rgba(107, 215, 131, 0.2)',
                  borderColor: 'rgba(107, 215, 131, 1)',
                  icon: 'mdi-check-circle-outline',
                  iconColor: 'rgba(107, 215, 131, 1)',
                  width: '600px'
                }
              )
              this.edit = false;
            })
            .catch(error => {
              console.error(error);
              reject(error);
              this.$root.$alertMessageRef.showAlert(
                this.$t('alert.USER_DATA_SAVE_FAILURE.title'),
                null,
                {
                  link: false,
                  action: false,
                  timeout: true,
                  timeoutDuration: 3000,
                  color: 'rgba(32, 30, 76, 1)',
                  backgroundColor: 'rgba(232, 69, 69, 0.2)',
                  borderColor: 'rgba(232, 69, 69, 1)',
                  icon: 'mdi-close-circle-outline',
                  iconColor: 'rgba(232, 69, 69, 1)',
                  width: '600px'
                }
              ) 
            })
            .finally(() => {
              window.scrollTo({ top: 0 });
              this.edit = false;
              this.loading_save = false;
              
            })
          })
        }
      })
			
		},
  }
}
</script>

<style lang="scss" scoped>
.reservation-screen-view {
	position: relative;
	// min-height: 100vh;
}
.edit_button {
  color: $ds-primary !important;
  // border: 1px solid $ds-primary;
}
.edit_button:disabled {
  color: gray !important;
}
.save_button {
  min-width: 153px;
}
.reservation-screen-wrapper {
	min-height: calc(100vh - 130px);
	// max-width: 588px;
	background: white;
	margin: 0 auto;
	position: relative;
	v-btn {
		@include nsb-font-header-bold;
	}
	.long {
		width: 100%;
	}
}
.reservation-screen-header {
	@include nsb-gentium-bold;
	font-size: 23px;
	line-height: 27px;
}
.reservation-screen-subheader {
	@include nsb-font-container;
	font-size: 14px;
	line-height: 21px;
	.id {
		@include nsb-inter-semibold;
		border-radius: 4px;
		background-color: #E7EBF1;
		font-size: 14px;
		line-height: 21px;
	}
	.reservation-label {
		@include nsb-font-container;
		font-size: 14px;
		line-height: 21px;
	}
}
.reservation-screen-data {
	width: calc(100% - 32px);
	.data-label {
		@include nsb-font-container-medium;
		font-size: 12px;
		line-height: 18px;
		color: $ds-label-1;
	}
	.data-value {
		@include nsb-font-container;
		font-size: 14px;
		line-height: 21px;
	}
	.data-subvalue {
		font-size: 12px;
		line-height: 18px;
		color: $ds-label-1;
	}
}
.reservation-screen-text {
	@include nsb-font-container;
	font-size: 16px;
	line-height: 24px;
}
.thank-you-screen {
	max-width: calc(588px + 48px);
	top: 50%;
}

.consent-wrapper {
	.consent {
		@include nsb-font-container;
		font-size: 12px;
		line-height: 18px;
	}
}

.input-wrapper , .document-wrapper{
	width: 100%;
	.input-label {
		@include nsb-font-container;
		font-size: 14px;
		line-height: 21px;
	}
	.input {
		@include nsb-font-input;
		font-size: 16px !important;
    line-height: 24px;
		height: 40px;
    width: 100%;
		padding: 0px 16px;
    border-radius: 4px;
    border: 1px solid $ds-background-1;
		text-overflow: ellipsis;
	}
	.select-wrapper {
		position: relative;
    display: inline-block;
    width: 100%;
    &.inside {
      width: calc(100% - 24px);
    }
		.select {
			@include nsb-font-input;
      font-size: 16px !important;
      line-height: 24px;
      height: 40px;
      padding: 0px 32px 0px 16px;
      width: 100%;
      border-radius: 4px;
      border: 1px solid $ds-background-1;
      // outline: none;
      text-overflow: ellipsis;
			option:disabled {
				color: $nsb-disabled-text;
			}
		}
		.chevron {
			position: absolute;
			right: 16px;
			top: 8px;
			pointer-events: none;
		}
	}
	.date-wrapper {
		position: relative;
		.select {
			@include nsb-font-input;    
      font-size: 16px !important;
      line-height: 24px;
      height: 40px;
      // width: 150px;
      // min-width: 80px;
      padding: 0px 16px;
      border-radius: 4px;
      border: 1px solid $ds-background-1;
      outline: none;
			text-overflow: ellipsis;
			option:disabled {
				color: $nsb-disabled-text;
			}
		}
		.long {
			width: 100%;
		}
		.chevron {
			position: absolute;
			right: 16px;
			top: 8px;
			pointer-events: none;
		}
	}
}
.full-date-wrapper {
  width: 282px;
}
.validation {
  @include nsb-validation;
}

.progress {
	position: fixed;
	top: 50vh;
	left: 50vw;
	transform: translate(-50%,-50%);
}

.progress_summary {
	position: absolute;
	top: 60%;
	left: 50%;
	transform: translate(-50%,-50%);
}

:deep(.link) {
	text-decoration: underline !important;
}

.reservation_disabled {
	position: relative;
	// filter: grayscale(1);
	// background: rgba(0,0,0,0.05);
	pointer-events: none;
	user-select: none;
}
.reservation_disabled_info {
	@include nsb-font-header-bold;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%,-50%);
	font-size: 32px;
	color: red !important;
}

@media (min-width: 960px) {
	.thank-you-screen {
		margin: 25% auto;
	}
	.reservation-screen-wrapper {
		min-height: unset;
	}
  .input-wrapper{
    .input {
      width: 282px;
    }
  }
  .select-wrapper {
    width: auto !important;
    .select {
      width: 282px !important;
    }
  } 
}
/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 24px;
  cursor: pointer;
  user-select: none;
}

/* Hide the browser's default checkbox */
.container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

/* Create a custom checkbox */
.checkmark {
  box-sizing: border-box;
  border: 1px solid #869AB7;
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 16px;
  background-color: white;
}

/* On mouse-over, add a grey background color */
.container:hover input ~ .checkmark {
  background-color: $nsb-disabled;
}

/* When the checkbox is checked, add a blue background */
.container input:checked ~ .checkmark {
  background-color: $ds-primary;
}

/* Create the checkmark/indicator (hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the checkmark when checked */
.container input:checked ~ .checkmark:after {
  display: block;
}

/* Style the checkmark/indicator */
.container .checkmark:after {
  left: 5px;
  top: 2px;
  width: 4px;
  height: 9px;
  border: solid white;
  border-width: 0 1px 1px 0;
  -webkit-transform: rotate(45deg);
  -ms-transform: rotate(45deg);
  transform: rotate(45deg);
}

input.disabled {
  pointer-events: none;
  border: none;
	background-color: $nsb-disabled;
	color: $nsb-disabled-text;
  cursor: default;
}

.wrapper {
  width: 100%;
}
</style>